/** @format */

import {
  getAuth,
  signInWithEmailAndPassword,
  signInWithPopup,
  createUserWithEmailAndPassword,
  signOut as firebaseSignOut,
} from 'firebase/auth'

import { getCurrentProvider, authPromiseHandler } from '../../utils'
import { authSocial, signUp, signIn, signOut, forgot } from './actions'

export const authSocialFetch = (type) => (dispatch) => {
  dispatch(authSocial.request())

  authPromiseHandler(
    dispatch,
    signInWithPopup(getAuth(), getCurrentProvider(type)),
    authSocial,
  )
}

export const signUpFetch = (email, password) => (dispatch) => {
  dispatch(signUp.request())

  authPromiseHandler(
    dispatch,
    createUserWithEmailAndPassword(getAuth(), email, password),
    signUp,
  )
}

export const signInFetch = (email, password) => (dispatch) => {
  dispatch(signIn.request())

  authPromiseHandler(
    dispatch,
    signInWithEmailAndPassword(getAuth(), email, password),
    signIn,
  )
}

export const signOutFetch = () => (dispatch) => {
  dispatch(signOut.request())

  const auth = getAuth()

  firebaseSignOut(auth)
    .then((resp) => {
      localStorage.clear()
      dispatch(signOut.success(resp))
    })
    .catch(({ code, message }) => dispatch(signOut.error({ code, message })))
}

export const forgotPasswordFetch = () => (dispatch) => {
  dispatch(forgot.request())
}
